import { render } from "./VUploadItem.vue?vue&type=template&id=1f2dd124"
import script from "./VUploadItem.vue?vue&type=script&lang=js"
export * from "./VUploadItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bookdialysis/bookdialysis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__